import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Grid,
} from "@mui/material";
import {
  CustomDialogProps,
  SmartForm,
  SmartSubmit,
  SmartTextField,
  useSmartForm,
} from "@nodeon/react-components";
import { useMemo } from "react";
import { useTranslation } from "react-i18next";
import { ProjectAddDto } from "~/api/GeneratedApi";
import { useAddProjects } from "../Wpr/hooks/useProjects";

type FormProps = {
  id: string;
  name: string;
  clientName: string;
};
interface Props {
  onSubmitted: () => void;
}

// TODO REPLACE DemoPTOPProjectListDto with PTOPProjectListDto
// Omitattu Id pois, koska se tulee bäkkäriltä
// formprops id === projectId (string)
const formToDto = (d: FormProps): ProjectAddDto => {
  const dto: ProjectAddDto = {
    name: d.name,
    projectId: d.id,

    clientName: d.clientName,
  };
  return dto;
};

export const ProjectCreationDialog = ({
  handleClose,
  onSubmitted,
}: CustomDialogProps & Props): JSX.Element => {
  const { t } = useTranslation("projects");

  const { addProject } = useAddProjects();

  const defaultValues: FormProps = useMemo(
    () => ({
      id: "",
      name: "",
      projectManager: "",
      clientName: "",
      typeName: "",
    }),
    [],
  );

  const methods = useSmartForm<FormProps>({
    defaultValues,
  });

  const onSubmit = (data: FormProps) => {
    // TODO DATA TO BookingListColums

    // if (Number.isNaN(Number(data.id))) {
    //   enqueueSnackbar(t("form:id-must-be-number"), { variant: "error" });
    //   return;
    // }
    const dto = formToDto(data);

    if (!dto) return;
    addProject(dto);
    handleClose?.();
    onSubmitted?.();
  };
  return (
    <Dialog open onClose={handleClose} aria-labelledby="form-dialog-title">
      <SmartForm<FormProps> onSubmit={onSubmit} noGrid methods={methods}>
        <DialogTitle id="form-dialog-title">{t("add-project")}</DialogTitle>
        <DialogContent>
          <Grid container spacing={2}>
            <Grid item xs={12}>
              <SmartTextField
                fullWidth
                label={t("projects:name")}
                name="name"
                required
              />
            </Grid>
            <Grid item xs={12}>
              <SmartTextField
                required
                fullWidth
                label={t("projects:id")}
                name="id"
              />
            </Grid>

            <Grid item xs={12}>
              <SmartTextField
                fullWidth
                label={t("projects:clientName")}
                name="clientName"
              />
            </Grid>
            {/* <Grid item xs={12}>
              <SmartAutoComplete
                options={[
                  "32022A03 Traficom - ASKO2022",
                  "32022A03 Traficom - ASKO2022 (v2)",
                ]}
                label="Projekti"
                name="project"
              />
            </Grid> */}
          </Grid>
        </DialogContent>
        <DialogActions>
          <Button onClick={handleClose} color="primary">
            {t("general:cancel")}
          </Button>
          <SmartSubmit>{t("add")}</SmartSubmit>
        </DialogActions>
      </SmartForm>
    </Dialog>
  );
};
